var alignment_rtlignore_default = {
  "alignLeft": "VJPWZ",
  "textWrapNowrap": "_0LbdF",
  "alignRight": "bqkEQ",
  "alignCenter": "E17Fq",
  "sizeFullWidth": "oHi56",
  "renderedInTable": "_0TRem",
  "sizeOriginal": "ALPan",
  "sizeContent": "JVmqT",
  "sizeSmall": "_2cx5p",
  "sizeSmallCenter": "Vqg0X",
  "flex": "O1Q-5",
  "LEFT": "B-qm2",
  "CENTER": "_6lCPE",
  "RIGHT": "-wV23",
  "AUTO": "_6aO1J",
  "JUSTIFY": "p7SZS"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
